export default __webpack_public_path__ + "static/media/bell.b9264059.svg";